{
  "CSAT": {
    "TITLE": "Оцените разговор",
    "PLACEHOLDER": "Расскажите подробнее...",
    "RATINGS": {
      "POOR": "😞 Плохо",
      "FAIR": "😑 Справедливо",
      "AVERAGE": "😐 Среднее",
      "GOOD": "😀 Хорошо",
      "EXCELLENT": "😍 Отлично"
    }
  }
}
